import { createContext } from 'react';
import { useInitBackgroundUploads } from './background-upload.hooks';
import { FileWithPath } from 'react-dropzone';
import { ProcessedFileStatus } from 'api/menu-service/menu-service.types';

export type BackgroundUploadContextType = {
  uploads: Record<string, BackgroundUpload>;
  addUpload: (upload: Omit<BackgroundUpload, 'uploadComplete'>) => void;
};

export type FileUploadObject = {
  file: FileWithPath;
  additionalData: Record<string, any>; // things like a url to upload to
  status: ProcessedFileStatus;
  statusMessage: string;
};

export type BackgroundUpload = {
  id: string;
  files: Record<string, FileUploadObject>;
  uploadFn: (file: FileUploadObject) => Promise<any>;
  onComplete: (backgroundUpload: BackgroundUpload) => Promise<void>;
  uploadComplete: boolean;
};

export const BackgroundUploadContext = createContext<
  BackgroundUploadContextType | undefined
>(undefined);

const BackgroundUploadProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const value = useInitBackgroundUploads({ maxConcurrent: 5 });

  return (
    <BackgroundUploadContext.Provider value={value}>
      {children}
    </BackgroundUploadContext.Provider>
  );
};

export default BackgroundUploadProvider;
